<template>
  <div class="errPage-container">
    <w-button type="minor" class="pan-back-btn" @click="back">
      返回主页
    </w-button>
    <w-row>
      <w-col :span="12">
        <h1 class="text-jumbo text-ginormous">
          Oops!
        </h1>
        <h2>你没有权限去该页面</h2>
        <h6>请联系企业管理员开通权限</h6>
        <ul class="list-unstyled">
          <li>或者你可以去:</li>
          <li class="link-type">
            <router-link to="/index">
              回首页
            </router-link>
          </li>
        </ul>
      </w-col>
      <w-col :span="12">
        <img :src="errGif" width="313" height="428" alt="">
      </w-col>
    </w-row>
  </div>
</template>

<script>
import errGif from '@/assets/images/401_images/401.gif'

export default {
  name: 'Page401',
  data () {
    return {
      errGif: errGif + '?' + +new Date()
    }
  },
  methods: {

    back () {
      this.$router.push({path: '/home'})
      // if (this.$route.query.noGoBack) {
      //   this.$router.push({path: '/home'})
      // } else {
      //   this.$router.go(-1)
      // }
    }
  }
}
</script>

<style lang="less" scoped>
  .errPage-container {
    width: 800px;
    max-width: 100%;
    margin: 100px auto;

    .pan-back-btn {
      background: #008489;
      color: #fff;
      border: none !important;
    }

    .pan-gif {
      margin: 0 auto;
      display: block;
    }

    .pan-img {
      display: block;
      margin: 0 auto;
      width: 100%;
    }

    .text-jumbo {
      font-size: 60px;
      font-weight: 700;
      color: #484848;
    }

    .list-unstyled {
      font-size: 14px;

      li {
        padding-bottom: 5px;
      }

      a {
        color: #008489;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>
